var init = function (element) {

    var hoverItem = element.querySelectorAll('[data-hover-item]');

    hoverItem.forEach((el, index) => {

        // el.setAttribute("data-modal-carousel-item", index);
        el.addEventListener('mouseover', function (e) {

            var id = document.getElementById(el.dataset.hoverItem);

            element.querySelectorAll('[data-hover-target]').forEach((target, index) => {
                target.classList.remove('is-active')
            });

            hoverItem.forEach((target, index) => {
                target.classList.remove('is-active')
            });

            id.classList.add('is-active');
            el.classList.add('is-active');

        });
    });
}

var components = document.querySelectorAll('[data-hover-component]');

if (components) {
    for (var i = 0; i < components.length; i++) {
        var j = components[i];
        init(j)
    }
}